var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRechargePhoneWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    transform: "translate(-218 -3926)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1196,
    transform: "translate(-223 -830)",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -163,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -24,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4915 51.7082C40.4198 51.7082 38.2382 51.2132 35.9832 50.2598C33.7832 49.3248 31.5648 48.0415 29.4015 46.4832C27.2565 44.9065 25.1848 43.1465 23.2232 41.2215C21.2798 39.2598 19.5198 37.1882 17.9615 35.0615C16.3848 32.8615 15.1198 30.6615 14.2215 28.5348C13.2682 26.2615 12.7915 24.0615 12.7915 21.9898C12.7915 20.5598 13.0482 19.2032 13.5432 17.9382C14.0565 16.6365 14.8815 15.4265 15.9998 14.3815C17.4115 12.9882 19.0248 12.2915 20.7482 12.2915C21.4632 12.2915 22.1965 12.4565 22.8198 12.7498C23.5348 13.0798 24.1398 13.5748 24.5798 14.2348L28.8332 20.2298C29.2182 20.7615 29.5115 21.2748 29.7132 21.7882C29.9515 22.3382 30.0798 22.8882 30.0798 23.4198C30.0798 24.1165 29.8782 24.7948 29.4932 25.4365C29.2182 25.9315 28.7965 26.4632 28.2648 26.9948L27.0182 28.2965C27.0365 28.3515 27.0548 28.3882 27.0732 28.4248C27.2932 28.8098 27.7332 29.4698 28.5765 30.4598C29.4748 31.4865 30.3182 32.4215 31.1615 33.2832C32.2432 34.3465 33.1415 35.1898 33.9848 35.8865C35.0298 36.7665 35.7082 37.2065 36.1115 37.4082L36.0748 37.4998L37.4132 36.1798C37.9815 35.6115 38.5315 35.1898 39.0632 34.9148C40.0715 34.2915 41.3548 34.1815 42.6382 34.7132C43.1148 34.9148 43.6282 35.1898 44.1782 35.5748L50.2648 39.9015C50.9432 40.3598 51.4382 40.9465 51.7315 41.6432C52.0065 42.3398 52.1348 42.9815 52.1348 43.6232C52.1348 44.5032 51.9332 45.3832 51.5482 46.2082C51.1632 47.0332 50.6865 47.7482 50.0815 48.4082C49.0365 49.5632 47.8998 50.3882 46.5798 50.9198C45.3148 51.4332 43.9398 51.7082 42.4915 51.7082ZM20.7482 15.0415C19.7398 15.0415 18.8048 15.4815 17.9065 16.3615C17.0632 17.1498 16.4765 18.0115 16.1098 18.9465C15.7248 19.8998 15.5415 20.9082 15.5415 21.9898C15.5415 23.6948 15.9448 25.5465 16.7515 27.4532C17.5765 29.3965 18.7315 31.4132 20.1982 33.4298C21.6648 35.4465 23.3332 37.4082 25.1665 39.2598C26.9998 41.0748 28.9798 42.7615 31.0148 44.2465C32.9948 45.6948 35.0298 46.8682 37.0465 47.7115C40.1815 49.0498 43.1148 49.3615 45.5348 48.3532C46.4698 47.9682 47.2948 47.3815 48.0465 46.5382C48.4682 46.0798 48.7982 45.5848 49.0732 44.9982C49.2932 44.5398 49.4032 44.0632 49.4032 43.5865C49.4032 43.2932 49.3482 42.9998 49.2015 42.6698C49.1465 42.5598 49.0365 42.3582 48.6882 42.1198L42.6015 37.7932C42.2348 37.5365 41.9048 37.3532 41.5932 37.2248C41.1898 37.0598 41.0248 36.8948 40.4015 37.2798C40.0348 37.4632 39.7048 37.7382 39.3382 38.1048L37.9448 39.4798C37.2298 40.1765 36.1298 40.3415 35.2865 40.0298L34.7915 39.8098C34.0398 39.4065 33.1598 38.7832 32.1882 37.9582C31.3082 37.2065 30.3548 36.3265 29.1998 35.1898C28.3015 34.2732 27.4032 33.3015 26.4682 32.2198C25.6065 31.2115 24.9832 30.3498 24.5982 29.6348L24.3782 29.0848C24.2682 28.6632 24.2315 28.4248 24.2315 28.1682C24.2315 27.5082 24.4698 26.9215 24.9282 26.4632L26.3032 25.0332C26.6698 24.6665 26.9448 24.3182 27.1282 24.0065C27.2748 23.7682 27.3298 23.5665 27.3298 23.3832C27.3298 23.2365 27.2748 23.0165 27.1832 22.7965C27.0548 22.5032 26.8532 22.1732 26.5965 21.8248L22.3432 15.8115C22.1598 15.5548 21.9398 15.3715 21.6648 15.2432C21.3715 15.1148 21.0598 15.0415 20.7482 15.0415ZM36.0748 37.5182L35.7815 38.7648L36.2765 37.4815C36.1848 37.4632 36.1115 37.4815 36.0748 37.5182Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -47.5,
    y: -163,
    width: 625,
    height: 171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_0_1",
    x: -47.5,
    y: -28,
    width: 625,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    fill: "white",
    transform: "translate(-218 -3926)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargePhoneWhite);
export default __webpack_public_path__ + "static/media/recharge-phone-white.ad645c26f47d8e92d041380d8fc38245.svg";
export { ForwardRef as ReactComponent };